import { trendingItems } from '@/mocks/trending';

export default function TrendingGrid() {
  return (
    <section className="w-full bg-foreground-950 py-20 md:py-28">
      <div className="w-full px-6 md:px-10 max-w-[1400px] mx-auto">
        {/* Header */}
        <div className="flex flex-col lg:flex-row items-start gap-8 mb-14">
          <span className="inline-flex items-center px-4 py-1.5 border border-background-50/20 text-background-50/80 text-xs font-semibold rounded-full whitespace-nowrap">
            Trending Now
          </span>
          <h2 className="font-heading text-4xl md:text-5xl font-bold text-background-50 max-w-2xl leading-tight">
            Curated Product Lists
          </h2>
        </div>

        {/* Horizontal scroll cards */}
        <div className="flex gap-5 overflow-x-auto pb-4 -mx-6 md:-mx-10 px-6 md:px-10 scrollbar-hide">
          {trendingItems.map((item) => (
            <a
              key={item.name}
              href={item.linkUrl}
              target="_blank"
              rel="noopener nofollow"
              className="flex-shrink-0 w-[260px] md:w-[300px] group cursor-pointer"
            >
              <div className="aspect-square rounded-2xl overflow-hidden bg-background-100 mb-4">
                <img
                  src={item.imageUrl}
                  alt={`Superbuy ${item.name} Spreadsheet`}
                  title={`Superbuy ${item.name} Spreadsheet`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="px-1">
                <h4 className="text-base font-semibold text-background-50">{item.name}</h4>
                <p className="text-sm text-background-50/50 mt-0.5">{item.subtitle}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}